import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=3ff375a7&scoped=true&"
import script from "./ContactData.vue?vue&type=script&lang=js&"
export * from "./ContactData.vue?vue&type=script&lang=js&"
import style0 from "./ContactData.vue?vue&type=style&index=0&id=3ff375a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff375a7",
  null
  
)

export default component.exports